import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArJO: CultureInfo = {
  name: 'ar-JO',
  displayName: 'Arabic (Jordan)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-JO',
  parent: CultureInfoAr
};
